module.exports = __webpack_public_path__ + "static/media/sticky-note.b97c8fd0.svg";